import { render, staticRenderFns } from "./addSupport.vue?vue&type=template&id=5c7ba3f5"
import script from "./addSupport.vue?vue&type=script&lang=js"
export * from "./addSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports